module.exports = __webpack_public_path__ + "static/img/rrrr_19.ad9ce12.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_19.png
// module id = F4TN
// module chunks = 1